// Centralized social/contact links. Update once here when real handles are ready.
export const SOCIAL = {
  instagram: "https://www.instagram.com/ouryoungindia/",
  youtube: "https://www.youtube.com/@ouryoungindia",
  facebook: "https://www.facebook.com/ouryoungindia",
  whatsapp: "https://wa.me/917386666077",
  email: "mailto:hi@sharanyamena.com",
  phone: "tel:+917386666077",
};
